import { HighlightedString } from "$components/autocomplete/highlighted-string";
import { SuggestionWrapper } from "$components/autocomplete/suggestion";
import { makeStyles, Typography } from "@material-ui/core";
import type Fuse from "fuse.js";
import React, { Fragment } from "react";

export interface ActiveDiseaseOption {
  uuid: string;
  category?: string;
  catalogueCoding?: {
    icd10: {
      code: string;
      system: string | null;
    } | null;
    icd11: {
      code: string;
      system: string | null;
    } | null;
  } | null;
  displayName: string;
  categoryDisplayName?: string;
  keywords?: string[];
}

const useDiagnosisCodeStyles = makeStyles({
  root: {
    backgroundColor: "#ccc",
    padding: "2px 5px",
    borderRadius: "5px",
  },
});

const DiagnosisCode = ({ children }: WithChildren) => {
  const classes = useDiagnosisCodeStyles();
  return <span className={classes.root}>{children}</span>;
};

export type DiagnosisListOptionProps = {
  option: Fuse.FuseResult<ActiveDiseaseOption>;
};

const DiagnosisListOption = ({ option }: DiagnosisListOptionProps) => {
  const { item, matches } = option;
  const matchesDisplayName = matches.find((match) =>
    match.key.endsWith("displayName"),
  );
  const keywordMatches = matches.filter(
    (match) => !match.key.endsWith("displayName"),
  );

  return (
    <SuggestionWrapper>
      <Typography variant="body1">
        <HighlightedString
          string={matchesDisplayName?.value || item.displayName || ""}
          indices={matchesDisplayName?.indices || []}
        />
      </Typography>
      <Typography variant="subtitle2">
        <DiagnosisCode>
          {item.catalogueCoding?.icd11?.code ||
            item.catalogueCoding?.icd10?.code ||
            ""}
        </DiagnosisCode>
      </Typography>
      {!matchesDisplayName && keywordMatches.length > 0 && (
        <Typography variant="body1">
          {"("}
          {keywordMatches.map(({ value, indices }, i, arr) => (
            <Fragment key={`${value}-${indices.join("-")}`}>
              <HighlightedString string={value} indices={indices} />
              {i !== arr.length - 1 && ", "}
            </Fragment>
          ))}
          {")"}
        </Typography>
      )}
    </SuggestionWrapper>
  );
};

export default React.memo(DiagnosisListOption);
